import React from 'react';
import { ColorClassnames } from '../../../tailwind/src/theme';
import cls from 'classnames';
export interface LogoProps {
	className?: string;
	fill?: ColorClassnames;
}

export default function StashLogo(props: LogoProps) {
	const { className, fill = 'text-brandFill' } = props;
	return (
		<div
			className={cls(className, fill)} 
			style={{
				paddingLeft: '16px',
			}}
		>
			<svg
				version="1.1"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 1002 223"
				role="img"
			>
				<title>Stash Logo</title>
				<path
					fill="currentColor"
					d="M64.08.78C27.56.78 1 31.27 1 63.69a63 63 0 0063.08 63.28h77.22c16.59 0 32.49 13.39 32.49 31.66 0 18.26-14.23 33.2-32.49 33.2H4.27v30.41h142.45c36.66 0 63.84-28.35 63.84-63.64 0-33.88-27.9-62.33-63.84-62.33H67.69A32.42 32.42 0 0135.2 63.66c0-18.06 15.02-32.22 32.49-32.25h194.96v190.82h34.17V31.41h86.73V.77L64.08.78z"
				/>
				<path
					fill="currentColor"
					d="M966.23.76v95.53H831.64V.76h-34.77v221.46h34.77v-95.3h134.59v95.3H1001V.76h-34.77z"
				/>
				<path fill="currentColor" d="M491.51 191.6h-66.4v30.64h66.4V191.6z" />
				<path
					fill="currentColor"
					d="M703.66 96.27h-79.03a32.42 32.42 0 01-32.49-32.61c0-18.06 15.02-32.22 32.49-32.25h127.09V.77l-130.7.01c-36.53 0-63.08 30.49-63.08 62.91a63 63 0 0063.08 63.28h77.21c16.59 0 32.5 13.39 32.5 31.66 0 18.26-14.23 33.2-32.5 33.2H563.3L471.47.77H444.3L336.93 222.24h34.87l86.12-175.38 84.57 175.38h161.18c36.66 0 63.83-28.35 63.83-63.64 0-33.88-27.9-62.33-63.84-62.33z"
				/>
			</svg>
		</div>
	);
}

export function StashLogoButton(props: LogoProps) {
	return (
		<button>
			<StashLogo />
		</button>
	);
}
